import React, { useCallback } from 'react'

import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { IconButton, Typography } from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import CloseIcon from '@material-ui/icons/Close'
import { useShowRightMostPane } from 'pages/ProjectsPage/WorkspacePage/components/WorkspaceRightPane/context/RightMostPaneContext'
import { useEditorWithSidebar } from '../hooks'
import { useTrackedChangesPanelStyles } from '../styles'
import { TrackChangesPanelActionsProps } from '../types/types'

/**
 * Component to render the tracked changes panel actions.
 * @returns {JSX.Element} - TrackChangesPanelActions component
 */
export const TrackChangesPanelActions = (
    props: TrackChangesPanelActionsProps
) => {
    const {
        isActionPopoverDisplayed,
        handleActionPopoverClick,
        actionRef,
    } = props
    const {
        actionButtonGridBeta,
        toggleContainerBeta,
        actionsContainerBeta,
        toggleTitleBeta,
        moreIconBeta,
        closeButtonBeta,
        actionLabelBeta,
    } = useTrackedChangesPanelStyles()
    const { toggleSidebar } = useEditorWithSidebar()
    const { setShowRightMostPane } = useShowRightMostPane()

    const onClosePanel = useCallback(() => {
        toggleSidebar(false)
        setShowRightMostPane((prevState) => !prevState)
    }, [toggleSidebar, setShowRightMostPane])

    return (
        <GridItem
            data-testid="buttonGridItemBeta"
            className={actionButtonGridBeta}
        >
            <GridContainer className={toggleContainerBeta}>
                <GridItem className={actionsContainerBeta}>
                    <Typography
                        component="h1"
                        className={toggleTitleBeta}
                        title="Track Changes"
                        aria-label="Track Changes Panel"
                        tabIndex={0}
                    >
                        Track changes
                    </Typography>
                </GridItem>
                <GridItem>
                    <IconButton
                        className={moreIconBeta}
                        data-testid="moreActionButtonBeta"
                        title="More actions"
                        aria-haspopup="true"
                        aria-label="More actions button"
                        aria-expanded={isActionPopoverDisplayed}
                        onClick={handleActionPopoverClick}
                        disableRipple
                        disableFocusRipple
                        ref={actionRef as React.RefObject<HTMLButtonElement>}
                    >
                        <MoreVert fontSize="small" />
                    </IconButton>
                    <IconButton
                        className={closeButtonBeta}
                        data-testid="closePanelBeta"
                        onClick={onClosePanel}
                        title="Close panel"
                        disableRipple
                        disableFocusRipple
                        aria-label="Close panel"
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </GridItem>
            </GridContainer>
        </GridItem>
    )
}
